<template>
  <v-container>
    <InterestApportionmentBase/>
  </v-container>
</template>

<script>
import InterestApportionmentBase from '../../../components/Gl/InterestApportionment/InterestApportionmentBase.vue';

export default {
  name: 'CalaculateInterest',
  components: {
    InterestApportionmentBase,
  },
};
</script>
